<app-header></app-header>
<div>
  <section>
    <main>
      <div class="main_tab_driver_shift mt-2">
        <p-toolbar>
          <!--  DROPDOWN DRIVER SHIFT NAME -->
          <div class="custom_hide_show_filter_dropdown fontColorDark" style="width: 300px">
            <p-dropdown [options]="zoneViewList" [filter]="false" filterBy="zoneName" placeholder="Select Zone"
              (onChange)="zoneSelect()" optionLabel="zoneName" [(ngModel)]="selectedZone">
              <ng-template pTemplate="selectedItem">
                <div class="country-item country-item-value" style="display: flex; gap: 10px;">
                  <div>{{ selectedZone.zoneName }}</div>
                </div>
              </ng-template>
              <ng-template let-zoneList pTemplate="item">
                <div class="country-item">
                  <div class="font-bold">{{ zoneList.zoneName }}</div>
                </div>
              </ng-template>
            </p-dropdown>
          </div>


          <button (click)="zoneSelect()" class="refresh-button">
            <svg style="color: aliceblue;" class="icon" height="24" viewBox="0 0 24 24" width="24"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="m23.8995816 10.3992354c0 .1000066-.1004184.1000066-.1004184.2000132 0 0 0 .1000066-.1004184.1000066-.1004184.1000066-.2008369.2000132-.3012553.2000132-.1004184.1000066-.3012552.1000066-.4016736.1000066h-6.0251046c-.6025105 0-1.0041841-.4000264-1.0041841-1.00006592 0-.60003954.4016736-1.00006591 1.0041841-1.00006591h3.5146443l-2.8117154-2.60017136c-.9037657-.90005932-1.9079498-1.50009886-3.0125523-1.90012523-2.0083682-.70004614-4.2175733-.60003954-6.12552305.30001977-2.0083682.90005932-3.41422594 2.50016478-4.11715481 4.5002966-.20083682.50003295-.80334728.80005275-1.30543933.60003954-.50209205-.10000659-.80334728-.70004613-.60251046-1.20007909.90376569-2.60017136 2.71129707-4.60030318 5.12133891-5.70037568 2.41004184-1.20007909 5.12133894-1.30008569 7.63179914-.40002637 1.4058578.50003296 2.7112971 1.30008569 3.7154812 2.40015819l3.0125523 2.70017795v-3.70024386c0-.60003955.4016736-1.00006591 1.0041841-1.00006591s1.0041841.40002636 1.0041841 1.00006591v6.00039545.10000662c0 .1000066 0 .2000132-.1004184.3000197zm-3.1129707 3.7002439c-.5020921-.2000132-1.1046025.1000066-1.3054394.6000396-.4016736 1.1000725-1.0041841 2.200145-1.9079497 3.0001977-1.4058578 1.5000989-3.5146444 2.3001516-5.623431 2.3001516-2.10878662 0-4.11715482-.8000527-5.72384938-2.4001582l-2.81171548-2.6001714h3.51464435c.60251046 0 1.0041841-.4000263 1.0041841-1.0000659 0-.6000395-.40167364-1.0000659-1.0041841-1.0000659h-6.0251046c-.10041841 0-.10041841 0-.20083682 0s-.10041841 0-.20083682 0c0 0-.10041841 0-.10041841.1000066-.10041841 0-.20083682.1000066-.20083682.2000132s0 .1000066-.10041841.1000066c0 .1000066-.10041841.1000066-.10041841.2000132v.2000131.1000066 6.0003955c0 .6000395.40167364 1.0000659 1.0041841 1.0000659s1.0041841-.4000264 1.0041841-1.0000659v-3.7002439l2.91213389 2.8001846c1.80753138 2.0001318 4.31799163 3.0001977 7.02928871 3.0001977 2.7112971 0 5.2217573-1.0000659 7.1297071-2.9001911 1.0041841-1.0000659 1.9079498-2.3001516 2.4100418-3.7002439.1004185-.6000395-.2008368-1.2000791-.7029288-1.3000857z"
                transform="" />
            </svg>
          </button>
          <div>
            <p-overlayPanel #op>
              <ng-template pTemplate>
                <div class="overlay-content">
                </div>
              </ng-template>
            </p-overlayPanel>
          </div>
          <div class="list-card">

          </div>

          <!-- <div class="relative">
            <div *ngIf="isLoading" class="loader-line"></div>
            <div>
              <div class="no_data_found_">
                <img src="../../assets/images/no_data.jpg" />
              </div>
            </div>
          </div> -->
        </p-toolbar>
      </div>
    </main>
  </section>

  <div class="accordion fontColorDark">
    <div class="accordion-item boxBColor fontColorDark" *ngFor="let item of zoneQueList; let i = index">
      <div class="accordion-header boxBColor fontColorDark" (click)="toggleAccordion(i)">
        <h3 class="fontColorDark">{{ item.carType }}
        </h3>
        <div class="driver_counts">
          <span class="fontMediumBold"> Total Drivers: {{ item.drivers.length}}</span>
          <span class="icon">
            <ng-container *ngIf="activeIndexes[i]">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 8l-6 6h12l-6-6z" fill="currentColor" />
              </svg>
            </ng-container>
            <ng-container *ngIf="activeIndexes[i]">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 16l6-6H6l6 6z" fill="currentColor" />
              </svg>
            </ng-container>
          </span>
        </div>

      </div>
      <div class="accordion-content boxBColor" [ngClass]="{'active': activeIndexes[i]}">

        <div class="driver-boxes">
          <ng-container *ngFor="let driver of item.drivers; let nn = index">
            <div class="driver-box boxBColor fontColorDark" *ngIf="item.drivers.length > 0"
              [ngClass]="{'current-car': driver.isCurrentCar}">
              <div class="header">
                <p class="driver-index">{{nn + 1}}</p>
                <span *ngIf="driver.isCurrentCar" class="badge">Current Car</span>
              </div>
              <p><strong>Name:</strong> {{ driver.driverName }}</p>
              <p>
                <strong>Mobile: </strong>
                <a [href]="'tel:+' + sanitizeMobileNumber(driver.mobile)" class="call-link">+{{ driver.mobile }}</a>
              </p>
              <p><strong>Model Name:</strong> {{ driver.carModelName }}</p>
              <p><strong>Brand Name:</strong> {{ driver.carBrandName }}</p>
            </div>
          </ng-container>
          <div *ngIf="item.drivers.length == 0">
            <p>No Driver Available.</p>
          </div>
        </div>


        <!-- <div class="driver-boxes">
          <ng-container *ngFor="let driver of item.drivers; let nn = index">
            <div class="driver-box boxBColor fontColorDark" *ngIf="checkDriverObj(driver)">
              <p> {{nn + 1}} </p>
              <p><strong>Name:</strong> {{ driver.driverName }}</p>
              <p><strong>Mobile:</strong> +{{ driver.mobile }}</p>
              <p><strong>Current Car:</strong> {{ driver.isCurrentCar }}</p>
              <p><strong>Model Name:</strong> {{ driver.carModelName }}</p>
              <p><strong>Brand Name:</strong> {{ driver.carBrandName }}</p>
            </div>
          </ng-container>
          <div *ngIf="item.drivers.length == 0">
            <p> No Driver Available.</p>
          </div>
        </div> -->
      </div>
    </div>
    <div class="loader-container" *ngIf="isLoading">
      <div class="spinner"></div>
    </div>

    <!-- Fancy Warning Box -->
    <div *ngIf="isDataMissing" class="fancy-warning">
      <div class="warning-icon">
        <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="white">
          <circle cx="12" cy="12" r="10" fill="red" />
          <text x="12" y="16" fill="white" font-size="12px" text-anchor="middle" font-weight="bold">!</text>
        </svg>
      </div>
      <div class="warning-content">
        <strong>Warning:</strong> {{ warningMessage }}
      </div>
    </div>
  </div>
</div>